import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from '@material-ui/styles';
import { useEffect } from 'react';
import TextInput from './Inputs/TextInput';
import SelfInspectInput from './Inputs/SelfInspectInput';
import SelfInspectBackButton from '../../pages/self-inspect/SelfInspectBackButton';
import SelfInspectButton from './SelfInspectButton';
import SelfInspectQuestionLabel from './SelfInspectQuestionLabel';

// SERVICES

const styles = theme => ({
  //
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },

  topHalf: {
    flex: 1,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    // border: '1px solid red',
  },
  bottomHalf: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    // border: '1px solid green',
  },

  image: {
    maxHeight: '80%',
    maxWidth: '100%',
  },

  questionLabel: {
    fontSize: '2rem',
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 20,
  },

  answerContainer: {
    fontSize: '1.25rem',
    width: '100%',
    textAlign: 'center',
  },

  actionContainer: {
    //marginTop: 20,
    flexGrow: 0,
    flexBasis: 'auto',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    //background: 'orange',
    paddingTop: 5,
    paddingBottom: 5,
  },
});

const TextAreaCard = withStyles(styles)(
  ({
    // form values
    cardNumber,
    questionId,
    questionImage,
    questionLabel,
    questionLabel2,
    answerValue,
    showInput,
    alwaysEditable,
    inputType = 'text',
    hideActions,
    //
    // functions
    updateAnswer,
    resetAnswer,
    confirmAnswer,
    //
    // other
    isActive,
    classes,
    selfInspectIntro,
    goBack,
    hideBackButton,
  }) => {
    const [editing, setEditing] = useState(alwaysEditable);

    const handleChange = evt => {
      const value = evt.target.value;

      updateAnswer({
        cardNumber,
        questionId,
        value,
      });
    };

    const handleContinue = () => {
      confirmAnswer({
        cardNumber,
        questionId,
        answerValue,
      });
    };

    useEffect(() => {
      if (!isActive) {
        setEditing(false);
      }
    }, [isActive]);

    return (
      <div className={classes.container}>
        <div className={classes.container}>
          {!!questionImage && (
            <div className={classes.topHalf}>
              <img className={classes.image} src={questionImage} />
            </div>
          )}

          <div className={classes.bottomHalf}>
            {!!questionLabel && (
              <SelfInspectQuestionLabel
                isHeader
                style={{
                  marginBottom: 20,
                }}
              >
                {questionLabel}
              </SelfInspectQuestionLabel>
            )}

            {!!questionLabel2 && (
              <SelfInspectQuestionLabel
                isHeader
                style={{
                  marginTop: 20,
                  marginBottom: 20,
                }}
              >
                {questionLabel2}
              </SelfInspectQuestionLabel>
            )}

            <div className={classes.answerContainer}>
              <SelfInspectInput
                //
                type={inputType}
                value={answerValue}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className={classnames(classes.actionContainer)}>
          {!hideBackButton && <SelfInspectBackButton onClick={goBack} className="flex-1 mr-20" />}

          <SelfInspectButton
            //
            label={'Keep going!'}
            onClick={handleContinue}
            className="flex-1"
          />
        </div>
      </div>
    );
  },
);

TextAreaCard.propTypes = {};

TextAreaCard.defaultProps = {};

export default TextAreaCard;
